import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import T from 'i18n-react'
import styles from './styles.scss'
import InfoElement from './InfoElement'
import Divider from 'components/fulcrum/divider/Divider'
import { getMonthDateYearTimestampString, prettifyDuration } from 'helpers/DateUtil'

const getDuration = (startDate, endDate) => {
  const startMs = Date.parse(startDate)
  const endMs = endDate ? Date.parse(endDate) : (new Date()).getTime()
  const diffMs = Math.abs(endMs - startMs)
  return prettifyDuration(diffMs)
}

const getRevisionNumber = (revisionNumber) => {
  if(revisionNumber != null){
    return (
      <InfoElement 
        title={T.translate('project.lifecycle.dialog.revisionNumber')} 
        data={revisionNumber} 
      />
    )
  }
  return
}

const getPendingApprovals = (pendingApprovals) => {
  if(pendingApprovals && pendingApprovals.length > 0){
    return(
      <div>
        <h5 styleName='lifecycleStateHeader'>{T.translate('project.lifecycle.dialog.pendingApprovals')} </h5>
        {pendingApprovals.map((approver, index) => {
          return (
            <InfoElement title={approver.role} data={approver.userName} key={index} />
          )
        })}
      </div>
    )
  }
  return
}



const getCompletedApprovals = (completedApprovals) => {
  if(completedApprovals && completedApprovals.length > 0){
    return(
      <div>
        <h5 styleName='lifecycleStateHeader'>{T.translate('project.lifecycle.dialog.completedApprovals')}</h5>
        {completedApprovals.map((approver, index) => {
          return (
            <InfoElement title={approver.role} data={approver.name} key={index} />
          ) 
        })}
      </div>
    )
  }
  return
}

const getComments = (comments) => {
  if(comments && comments.length > 0){
    return(
      <div>
        <h5 styleName='lifecycleStateHeader'>{T.translate('project.lifecycle.dialog.comments')}</h5>
        {comments.map((comment, index) => {
          return (
            <InfoElement title={comment.name + ', ' + getMonthDateYearTimestampString(new Date(comment.date))} data={comment.comment} key={index} />
          )
        })}
      </div>
    )
  }
  return
}

const LifecycleStateInfo = (props) => {
  const { data } = props
  return (
    <div>
      <h4 styleName='lifecycleStateTitle'>{data.state}</h4>
      <InfoElement 
        title={T.translate('project.lifecycle.dialog.initiatedBy')} 
        data={data.createdByUserName} 
      />
      <InfoElement 
        title={T.translate('project.lifecycle.dialog.startDate')} 
        data={getMonthDateYearTimestampString(new Date(data.startDate))} 
      />
      <InfoElement 
        title={T.translate('project.lifecycle.dialog.endDate')} 
        data={data.endDate ? getMonthDateYearTimestampString(new Date(data.endDate)) : 'Ongoing'} 
      />
      <InfoElement 
        title={T.translate('project.lifecycle.dialog.duration')} 
        data={getDuration(data.startDate, data.endDate)} 
      />
      {getRevisionNumber(data.revisionCount)}
      {getPendingApprovals(data.pendingApprovals)}
      {getCompletedApprovals(data.completedApprovals)}
      {getComments(data.comments)}
      <Divider />
    </div>
  )
}

export default CSSModules(styles)(LifecycleStateInfo)
